export const AUTH_USER = 'AUTH_USER';
export const UNAUTH_USER = 'UNAUTH_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const TRY_CONNECT = 'TRY_CONNECT';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const UPDATE_USER_PROFILE_GOOD = 'UPDATE_USER_PROFILE_GOOD';
export const UPDATE_USER_PROFILE_FAIL = 'UPDATE_USER_PROFILE_FAIL';


// WEBPACK FOOTER //
// ./src/actions/types.js